<template>
  <div class="home">
    <select-product />
    <widget-catalog />
    <widget-brands />
    <widget-about />
    <widget-trust />
    <widget-articles />
    <widget-map />
  </div>
</template>

<script>
import SelectProduct from '../components/SelectProduct'
import WidgetCatalog from '../components/WidgetCatalog'
import WidgetBrands from '../components/WidgetBrands'
import WidgetAbout from '../components/WidgetAbout'
import WidgetTrust from '../components/WidgetTrust'
import WidgetArticles from '../components/WidgetArticles'
import WidgetMap from '../components/WidgetMap'
import { metaFromSeoOrDefaults } from '../seo/metaFromStore'

const SEO_FALLBACK = {
  title: 'Масла и технические жидкости TCL - моторные масла и антифризы для автомобилей',
  description:
    'Продукция TCL: моторные масла, антифризы и технические жидкости для автомобилей.',
  meta: '',
}

export default {
  name: 'home',
  components: {
    SelectProduct,
    WidgetCatalog,
    WidgetBrands,
    WidgetAbout,
    WidgetTrust,
    WidgetArticles,
    WidgetMap
  },
  computed: {
    resolvedSeo() {
      const s = this.$store.state.seoPage
      if (s && s.id) {
        return s
      }
      return SEO_FALLBACK
    },
  },
  metaInfo() {
    return metaFromSeoOrDefaults(this.$store, SEO_FALLBACK)
  },
}
</script>